// eslint-disable-next-line no-restricted-imports -- Temporary import until core is merged into the hendrx app.
import { clientModules } from '@hendrx/hendrx/clientModules';

import { useFetchAuthenticatedFileQuery } from './useFetchAuthenticatedFileQuery';

/**
 * Resolves the final file source, deciding between direct public access and authenticated private access.
 * @param src The original file path/URL reference
 * @returns The final URL string
 */
export function useFileAccessSrc(src: string): { src: string | undefined; isLoading: boolean } {
  const isPublic = clientModules.fileStorage.isPublicUrl(src);
  const isPrivate = !isPublic;

  const { data: authenticatedBlobUrl, isLoading: isLoadingAuthenticatedBlob } = useFetchAuthenticatedFileQuery(src, {
    enabled: isPrivate
  });

  let finalSrc: string | undefined;

  if (isPublic) {
    // Use the source directly for public URLs (CDN)
    finalSrc = src;
  } else if (authenticatedBlobUrl) {
    // Use the fetched blob URL for private files
    finalSrc = authenticatedBlobUrl;
  }

  const isLoading = isPublic ? false : isLoadingAuthenticatedBlob;
  return { src: finalSrc, isLoading };
}
